const Energy = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 64" {...props}>
		<path
			stroke="#CD0157"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={4}
			d="M29.333 2v23.333h20L22.667 62V38.667h-20L29.332 2Z"
		/>
	</svg>
);
export default Energy;
